import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import './styles.scss'

const Select = ({ title, options = [], error, required, placeholder = 'Select an option...', ...props }) => {
  return (
    <div className={`custom-select${error ? ' has-error' : ''}`}>
      <div className="label">
        {title}
        {required && <span className="required-mark"> *</span>}
      </div>

      <div className="select-wrapper">
        <select {...props}>
          <option value="">{placeholder}</option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <FontAwesomeIcon className="chevron" icon={solid('chevron-down')} />
      </div>

      {error && <span className="error-msg">{error}</span>}
    </div>
  )
}

export default Select
